module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_vm._v("\n   " + _vm._s(_vm.actionToBePerformed) + "\n  ")])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "col-xs-12 col-md-12 col-lg-12"
  }, [_c('form', {
    attrs: {
      "action": "#",
      "method": "post"
    }
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('label', {
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Country")]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.gRowObj.country_id.required
    },
    attrs: {
      "id": "country_id"
    },
    on: {
      "change": _vm.selectedCountry
    },
    model: {
      value: (_vm.gRowObj.country_id),
      callback: function($$v) {
        _vm.$set(_vm.gRowObj, "country_id", $$v)
      },
      expression: "gRowObj.country_id"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Choose a Country--")]), _vm._v(" "), _vm._l((_vm.countryList), function(data) {
    return _c('option', {
      key: data.country_id,
      domProps: {
        "selected": data.country_id === _vm.gRowObj.country_id,
        "value": data.country_id
      }
    }, [_vm._v(_vm._s(data.country_name))])
  })], 2), _vm._v(" "), (_vm.submitted && !_vm.$v.gRowObj.country_id.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please choose a country.")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "type"
    }
  }, [_vm._v("Customer")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.gRowObj.client_id.required
    },
    attrs: {
      "id": "client_id"
    },
    on: {
      "change": _vm.selectedClient
    },
    model: {
      value: (_vm.gRowObj.client_id),
      callback: function($$v) {
        _vm.$set(_vm.gRowObj, "client_id", $$v)
      },
      expression: "gRowObj.client_id"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Choose an Customer--")]), _vm._v(" "), _vm._l((_vm.clientList), function(data) {
    return _c('option', {
      key: data.id,
      domProps: {
        "value": data.id,
        "selected": data.id === _vm.gRowObj.client_id
      }
    }, [_vm._v(_vm._s(data.name))])
  })], 2), _vm._v(" "), (_vm.submitted && !_vm.$v.gRowObj.client_id.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please choose a client.")]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-4 col-sm-4 col-md-4"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "type"
    }
  }, [_vm._v("Keyword Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gRowObj.keyword_name),
      expression: "gRowObj.keyword_name"
    }],
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.gRowObj.keyword_name.required
    },
    attrs: {
      "type": "text",
      "id": "keyword_name",
      "placeholder": "Keyword Name"
    },
    domProps: {
      "value": (_vm.gRowObj.keyword_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.gRowObj, "keyword_name", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.submitted && !_vm.$v.gRowObj.keyword_name.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please Click on Generate Keyword Button OR Enter Keyword.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-2 col-sm-2 col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-top": "25px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.generateKeyword
    }
  }, [_vm._v("Generate Keyword")])]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-4 col-sm-4 col-md-4"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "type"
    }
  }, [_vm._v("Audience Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gRowObj.audience_name),
      expression: "gRowObj.audience_name"
    }],
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.gRowObj.audience_name.required
    },
    attrs: {
      "type": "text",
      "id": "audience_name",
      "placeholder": "Audience Name"
    },
    domProps: {
      "value": (_vm.gRowObj.audience_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.gRowObj, "audience_name", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.submitted && !_vm.$v.gRowObj.audience_name.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please Click on Generate Audience Button OR Enter Audience.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-2 col-sm-2 col-md-2"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "margin-top": "25px"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.generateAudience
    }
  }, [_vm._v("Generate Audience")])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('div', [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Type")]), _vm._v(" "), _c('nv-select', {
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.gRowObj.appPackage.required
    },
    attrs: {
      "id": "apppackage",
      "name": "apppackage"
    },
    on: {
      "change": function($event) {
        return _vm.onChangeType($event)
      }
    },
    model: {
      value: (_vm.gRowObj.appPackage),
      callback: function($$v) {
        _vm.$set(_vm.gRowObj, "appPackage", $$v)
      },
      expression: "gRowObj.appPackage"
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }, [_vm._v("--Choose an App Package--")]), _vm._v(" "), _vm._l((_vm.appPackages), function(data, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": data.value
      }
    }, [_vm._v(_vm._s(data.name))])
  })], 2), _vm._v(" "), (_vm.submitted && !_vm.$v.gRowObj.appPackage.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please choose an app package.")]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('div', [_c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.gRowObj.appPackage !== 'journey'),
      expression: "gRowObj.appPackage!=='journey'"
    }],
    staticClass: "required",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Conversation")]), _vm._v(" "), _c('label', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.gRowObj.appPackage === 'journey'),
      expression: "gRowObj.appPackage==='journey'"
    }],
    staticClass: "required",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("User Journey")]), _vm._v(" "), _c('treeselect', {
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.gRowObj.conversation.required
    },
    attrs: {
      "placeholder": "--Choose an app--",
      "multiple": false,
      "disabled": _vm.gRowObj.appPackage == '',
      "options": _vm.conversationApps
    },
    model: {
      value: (_vm.gRowObj.conversation),
      callback: function($$v) {
        _vm.$set(_vm.gRowObj, "conversation", $$v)
      },
      expression: "gRowObj.conversation"
    }
  }), _vm._v(" "), (_vm.submitted && !_vm.$v.gRowObj.conversation.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please choose a conversation.")]) : _vm._e()], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12 col-lg-12 col-xs-12"
  }, [_c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('label', {
    staticClass: "required",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Google Sheet URL")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gRowObj.spreadsheetURL),
      expression: "gRowObj.spreadsheetURL"
    }],
    staticClass: "form-control",
    class: {
      'form-group--error': _vm.submitted && !_vm.$v.gRowObj.spreadsheetURL.required
    },
    attrs: {
      "type": "text",
      "id": "spreadsheetURL",
      "placeholder": "Google Sheet URL"
    },
    domProps: {
      "value": (_vm.gRowObj.spreadsheetURL)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.gRowObj, "spreadsheetURL", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.submitted && !_vm.$v.gRowObj.spreadsheetURL.required) ? _c('span', {
    staticClass: "text-red pull-right"
  }, [_vm._v("Please enter URL of Google Sheet.")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-group col-xs-6 col-sm-6 col-md-6"
  }, [_c('div', {
    staticClass: "display-content"
  }, [_c('label', {
    staticClass: "checkbox-inline",
    staticStyle: {
      "margin-top": "23px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.gRowObj.isUploadInJOR),
      expression: "gRowObj.isUploadInJOR"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": _vm.gRowObj.isUploadInJOR,
      "checked": Array.isArray(_vm.gRowObj.isUploadInJOR) ? _vm._i(_vm.gRowObj.isUploadInJOR, null) > -1 : (_vm.gRowObj.isUploadInJOR)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.gRowObj.isUploadInJOR,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.gRowObj, "isUploadInJOR", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.gRowObj, "isUploadInJOR", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.gRowObj, "isUploadInJOR", $$c)
        }
      }
    }
  }), _vm._v(" "), _vm._m(2)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "action-button"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.close
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary margin-left-20px",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.uploadFHIUsers()
      }
    }
  }, [_vm._v("Submit")])])]), _vm._v(" "), _c('div', {
    staticClass: "row",
    staticStyle: {
      "margin": "30px 10px 30px 10px",
      "font-size": "medium",
      "line-height": "30px"
    }
  }, [_c('label', {
    staticStyle: {
      "font-size": "large"
    },
    attrs: {
      "for": "notes"
    }
  }, [_vm._v("Instructions:-")]), _vm._v(" "), _c('ul', [_vm._m(3), _vm._v(" "), _c('li', [_c('b', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("CAUTION: ")]), _vm._v("The google sheet which needs to be uploaded should only contains the details in a specific format.\n                    "), _c('ul', [_vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('li', [_c('b', [_vm._v("Country")]), _vm._v(" (Make a note that the first letter of the country must be a capital letter i.e. " + _vm._s(_vm.activeCountryList.join(', ')) + ")")])])]), _vm._v(" "), _vm._m(9), _vm._v(" "), _vm._m(10)])])])])])])])])]), _vm._v(" "), (_vm.loading) ? _c('BlockUI', [_c('i', {
    staticClass: "fa fa-cog fa-spin fa-3x fa-fw"
  }), _c('br'), _vm._v("Please wait...")]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_vm._v("Configuration")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    attrs: {
      "title": "The keyword and audience query will only work for the country which is selected from this dropdown."
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle required"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b', [_vm._v("Onboard users to JOR? "), _c('span', {
    attrs: {
      "title": "Please select this field only when users are to be onboarded directly into the selected JoR"
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle margin-10"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    attrs: {
      "id": "notes"
    }
  }, [_vm._v("Please upload the Google Sheet in this folder :- "), _c('a', {
    attrs: {
      "href": "https://drive.google.com/drive/folders/1Vb7nmtQoqEvBFjW3LqoSUtfptnx5u6sq",
      "target": "_blank"
    }
  }, [_vm._v("https://drive.google.com/drive/folders/1Vb7nmtQoqEvBFjW3LqoSUtfptnx5u6sq")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('b', [_vm._v("Phone Number")]), _vm._v(" (Add the country code before the phone number and do not enter any kind of special characters in it)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('b', [_vm._v("Language")]), _vm._v(" must be one of the following options :- eng, hi, swa, hau (Please take a note of this, and change the language to one of these options wherever necessary)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('b', [_vm._v("Gender")]), _vm._v(" must be one of the following options :- man, woman, nonbinary (Please take a note of this, and do not use male or female in the google sheets)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('b', [_vm._v("Age")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('b', [_vm._v("Pincode")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_vm._v("The sequence of the users data must be "), _c('b', [_vm._v("Phone Number, Language, Gender, Age, Pincode, Country")]), _vm._v(".")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('div', {
    attrs: {
      "id": "referenceSheet"
    }
  }, [_vm._v("Here is a demo sheet for your reference :- "), _c('a', {
    attrs: {
      "href": "https://docs.google.com/spreadsheets/d/18HVveQmCpHEAnddx3Neaxem1wITtPlMCr0QpDq_e03I/edit?usp=sharing",
      "target": "_blank"
    }
  }, [_vm._v("https://docs.google.com/spreadsheets/d/18HVveQmCpHEAnddx3Neaxem1wITtPlMCr0QpDq_e03I/edit?usp=sharing")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-7528803e","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user-upload/index.vue
// module id = G5M1
// module chunks = 1